import { Currency } from "@redotech/money/iso4217/currencies";
import { CheckoutSegmentCategory } from "@redotech/redo-model/conversion/checkout-segments/checkout-segment-category";
import * as z from "zod/v4";

export const getSegmentedCheckoutMetrics = {
  name: "getSegmentedCheckoutMetrics" as const,
  input: z.null(),
  output: z.object({
    segments: z.array(
      z.object({
        segmentKey: z.string(),
        name: z.string(),
        category: z.enum(CheckoutSegmentCategory),
        totalCheckoutVisits: z.number(),
        totalCheckoutCompletions: z.number(),
        aov: z.number(),
        conversionRate: z.number(),
        revenuePerCheckoutVisit: z.object({
          amount: z.number(),
          currency: z.enum(Currency),
        }),
      }),
    ),
  }),
};
export type GetSegmentedCheckoutMetricsOutput = z.infer<
  typeof getSegmentedCheckoutMetrics.output
>;
